"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Dictionary = _interopRequireDefault(require("../Dictionary"));

var _QueryContext = _interopRequireDefault(require("./QueryContext"));

var _useMediaQueryContext = _interopRequireDefault(require("./QueryContext/useMediaQueryContext"));

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      dictionary = _ref.dictionary,
      children = _ref.children;
  var media = (0, _useMediaQueryContext.default)();
  return /*#__PURE__*/React.createElement(_QueryContext.default.Provider, {
    value: media
  }, /*#__PURE__*/React.createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, dictionary ? /*#__PURE__*/React.createElement(_Dictionary.default, {
    values: dictionary
  }, React.Children.only(children)) : React.Children.only(children)));
};

var _default = ThemeProvider;
exports.default = _default;